import React from 'react';
import { useNavigate } from 'react-router-dom';

const BackButton: React.FC<{
  overridePage?: string
}> = (props) => {
  const navigate = useNavigate();

  const handelGoBack = () => {
    if(props.overridePage)
    {
      navigate(props.overridePage);
      return;
    }
    
    navigate(-1);
  }

  return (
    <button className="btn-back mb-2" onClick={handelGoBack}>
      Tilbage
    </button>
  );
};

export { BackButton };
